/**
 * Visual Artifacts
 *
 * Public exports for shared visual artifact data helpers.
 *
 * Primary responsibilities:
 * - Re-export visual artifact types
 * - Re-export validation helpers and fixtures
 *
 * Dependencies:
 * - Visual artifact modules
 */

export * from './types'
export * from './validation'
export * from './fixtures'
export * from './markers'
export * from './library-metadata'
export * from './workflow-actions'
